export default __webpack_public_path__ + "static/media/Palletech 14.7ca0e246.jpg";